<template>
    <div class="main-wrapper">
        <layouts></layouts>

            <div class="page-wrapper">
                <servicegallery />

                <servicedescription />

                <servicecontent />

                <foot />

                <scroll />
            </div>
        
    </div>
</template>

